import { FC, useRef } from "react";
import { defineMessages, useIntl } from "react-intl";
import { SearchBox as OfficeSearchBox, PrimaryButton, Stack } from "@fluentui/react";
import { IFormField } from "cayo.ui";
import { newQuery, setCondition } from "@cayo/shared/components/GridContainer/gridModel/Query";
import {
  ConditionType,
  IAnrCondition,
  IQuery,
  DispatchAction,
} from "@cayo/shared/components/GridContainer/types";

type IAnrSearchBoxProps = {
  query?: IQuery;
  dispatch: DispatchAction;
  width?: number;
  previewQueryId?: string | null;
  showSearchButton: boolean;
  hideSearchText?: boolean;
} & Omit<IFormField, "type">;

const AnrSearchBox: FC<IAnrSearchBoxProps> = (props) => {
  const value = ((
    props.query?.conditions.find((c) => c.kind === ConditionType.Anr) as Readonly<IAnrCondition>
  )?.value ?? "") as string;

  const { placeHolder, disabled, showSearchButton, hideSearchText } = props;

  const intl = useIntl();
  const key = "sb-" + (value ?? "");

  const handleSetAnr = (v?: string) => {
    const query = setCondition(props.query ?? newQuery(), {
      kind: ConditionType.Anr,
      value: v ?? "",
    });
    props.dispatch({ kind: "changeQuery", previewQuery: !!props.previewQueryId, query });
  };

  const searchRef = useRef<HTMLDivElement>(null);
  const searchBox = (
    <OfficeSearchBox
      key={key}
      ref={searchRef}
      defaultValue={value}
      onSearch={(value) => {
        handleSetAnr(value);
      }}
      onClear={() => {
        handleSetAnr("");
      }}
      // onChange={(_, value) => {
      //   if (value === "") {
      //     props.setValue("");
      //   }
      // }}
      styles={{ root: { width: props.width } }}
      placeholder={placeHolder || intl.formatMessage(messages.search)}
      width={props.width}
      disabled={disabled}
      maxLength={100}
    />
  );

  if (showSearchButton !== false) {
    return (
      <Stack horizontal tokens={{ childrenGap: 4 }}>
        {hideSearchText ? null : searchBox}
        <PrimaryButton
          onClick={() => handleSetAnr(searchRef.current?.querySelector("input")?.value)}
        >
          {intl.formatMessage(messages.search)}
        </PrimaryButton>
      </Stack>
    );
  }
  return searchBox;
};

const messages = defineMessages({ search: { id: "search-box.search", defaultMessage: "Search" } });

export default AnrSearchBox;
